import * as Mutations from "./mutations";
import { PayNowService } from "../../../common/services/pay-now.service";

export const PayNowModule = {
  state: {
    methods: [],
    clientSecret: null,
    paymentPayload: {},
    isCleaningInProgress: false,
    invoiceData: {
      paymentId: null,
      amount: 0,
      discounts: [],
      addons: [],
      total: 0,
      totalAddon: 0,
      totalDiscount: 0,
      billingType: null,
      child: {
        firstName: null,
        lastName: null,
      },
      activityName: null,
      coupon: null,
    },
    payNowActivityId: null,
    isChargeFlow: false,
    payNowEnrollmentData: {},
    paymentType: null,
  },

  mutations: {
    [Mutations.SET_PAYMENT_METHODS](state, methods) {
      state.methods = methods;
    },
    [Mutations.SET_PAYMENT_PAYLOAD](state, paymentPayload) {
      state.paymentPayload = paymentPayload;
    },
    [Mutations.SET_PAYMENT_TYPE](state, paymentType) {
      state.paymentType = paymentType;
    },
    [Mutations.SET_IS_CLEANING_IN_PROGRESS](state, isCleaningInProgress) {
      state.isCleaningInProgress = isCleaningInProgress;
    },
    [Mutations.SET_PAY_NOW_ACTIVITY_ID](state, payNowActivityId) {
      state.payNowActivityId = payNowActivityId;
    },
    [Mutations.SET_INVOICE_DATA](state, invoiceData) {
      state.invoiceData = invoiceData;
    },
    [Mutations.SET_IS_CHARGE_FLOW](state, isChargeFlow) {
      state.isChargeFlow = isChargeFlow;
    },
    [Mutations.SET_PAY_NOW_ENROLLMENT_DATA](state, payNowEnrollmentData) {
      state.payNowEnrollmentData = payNowEnrollmentData;
  },
  },

  actions: {
    setPayNowEnrollemtData: ({ commit }, payNowEnrollmentData) => {
      commit(Mutations.SET_PAY_NOW_ENROLLMENT_DATA, payNowEnrollmentData);
  },

    cancelPaymentFlow: async ({ dispatch, getters, state }) => {
      try {
          const enrollmetData = getters.payNowEnrollmentData;
          const payNowActivityId = getters.payNowActivityId;
          const schoolSlug = getters.schoolInfo.portalName;
          const { parentId, schoolId } = getters.paymentPayload;
          if (enrollmetData) {

            switch (enrollmetData.activityType) {
              case "Class":
                await PayNowService.cancelClassPaymentFlow(schoolSlug, enrollmetData.activityId, enrollmetData.childId, payNowActivityId);
                dispatch("createSuccessNotification", "Payment cancelled");
                break;
              case "Aftercare":
                 await PayNowService.cancelAftercarePaymentFlow(schoolId, enrollmetData.activityId, payNowActivityId, enrollmetData.childId);
                 dispatch("createSuccessNotification", "Payment cancelled"); 
                 break;
              case "DropIn":
                  await PayNowService.cancelAftercareDropInPaymentFlow(schoolId, enrollmetData.activityId, payNowActivityId);
                  dispatch("createSuccessNotification", "Payment cancelled"); 
                  break;
              case "Camp":
                    await PayNowService.cancelCampPaymentFlow(schoolId, enrollmetData.activityId, payNowActivityId);
                    dispatch("createSuccessNotification", "Payment cancelled"); 
                    break;
              default:
                break;
            }
             
          }

      } catch (error) {
        dispatch("createErrorNotification", "Failed to cancel payment");
      }
    },

    applyCoupon: async ({ dispatch, commit, getters }, { paymentId, coupon }) => {
      try {
        const {data: {content}} = await PayNowService.getAllCoupons(getters.schoolId, null);
        const couponToApply = content.find((c) => c.name === coupon);
        if (couponToApply) {
          const res = await PayNowService.applyCoupon(paymentId, couponToApply.stripeCoupon);
          dispatch("createSuccessNotification", "Coupon applied successfully");
          commit(Mutations.SET_INVOICE_DATA, res); 
          
        } else {
          dispatch("createErrorNotification", "Coupon not found");
        }
      } catch (error) {
        dispatch("createErrorNotification", "Failed to apply coupon");
      } finally {

      }
    },

    setChargeFlow({ commit }, isChargeFlow) {
      commit(Mutations.SET_IS_CHARGE_FLOW, isChargeFlow);
    },

    addToWAITLIST: async ({ dispatch }) => {
      await PayNowService.addToWaitlist();
    },

    setPayNowActivityId: ({ commit }, payNowActivityId) => {
      commit(Mutations.SET_PAY_NOW_ACTIVITY_ID, payNowActivityId);
    },

    setInvoiceData: ({ commit }, invoiceData) => {
      commit(Mutations.SET_INVOICE_DATA, invoiceData);
    },
    getAllPaymentMethods: async ({ commit, getters, dispatch }) => {
      try {
        const { parentId, schoolId } = getters.paymentPayload;
        const methods = await PayNowService.getAllPaymentMethods(
          parentId,
          schoolId
        );
        commit(Mutations.SET_PAYMENT_METHODS, methods);
      } catch (error) {
        dispatch("createErrorNotification", "Failed to get payment methods");
      }
    },

    createInvoicePayment: async ({ dispatch, getters, state, commit }, paymentId) => {   

      const {parentId, schoolId} = getters.paymentPayload
      const {activityType} = getters.payNowEnrollmentData
      const payload = {
        "parentId": parentId,
        "schoolId": schoolId,
        "activityType": activityType,
        "activityId": paymentId,
        "paymentType": "INVOICE"
      };

      commit(Mutations.SET_PAYMENT_TYPE, "INVOICE");
      try {
        const invoice = await PayNowService.createPayment(payload);
        if (invoice) {
          dispatch("setInvoiceData", invoice);
          dispatch("closeModal", { dangerClose: true });
          dispatch("openModal", {
            modalName: "PayNowInvoiceModal",
            callback: () => ({}),
            options: {
              confirmOnClose: true,
            },
          });
        }
      } catch (error) {
        dispatch("cancelPaymentFlow");
        dispatch("createErrorNotification", "Failed to create payment");
      }
    },

    createPayment: async ({ dispatch, getters, state, commit }, paymentMethodId) => {
      const payload = {
        ...getters.paymentPayload,
        activityId: state.payNowActivityId,
        paymentMethodId,
        paymentType: "CHARGE",
        activityType: state.payNowEnrollmentData.activityType,
      };
      commit(Mutations.SET_PAYMENT_TYPE, "CHARGE");
      try {
        const invoice = await PayNowService.createPayment(payload);
        if (invoice) {
          dispatch("setInvoiceData", invoice);
          dispatch("closeModal", { dangerClose: true });
          dispatch("openModal", {
            modalName: "PayNowInvoiceModal",
            callback: () => ({}),
            options: {
              confirmOnClose: true,
            },
          });
        }
      } catch (error) {
        dispatch("cancelPaymentFlow");
        dispatch("createErrorNotification", "Failed to create payment");
      }
    },

    confirmPayment: async ({ dispatch, state }, paymentId) => {
      try {
        const paymentType = state.paymentType;
        await PayNowService.confirmPayment(paymentId);
        dispatch("createSuccessNotification", 
          paymentType === "INVOICE" ? "You have successfully created an invoice" : "Payment confirmed successfully");
      } catch (error) {
        dispatch("createErrorNotification", "Failed to confirm payment");
      } finally {
        dispatch("closeModal", { dangerClose: true });
      }
    },

    initPaymentData: async ({ dispatch, commit, getters, state }, parentId) => {
      try {
        await dispatch("getSchoolInfo");
        const schoolId = getters.schoolInfo.id;
        const activityType = state.payNowEnrollmentData.activityType

        commit(Mutations.SET_PAYMENT_PAYLOAD, {
          parentId,
          schoolId,
          activityType,
        });
      } catch (error) {
        dispatch(
          "createErrorNotification",
          "Failed to initialize payment data"
        );
      }
    },
  },

  getters: {
    paymentMethods: (state) => state.methods,
    clientSecret: (state) => state.clientSecret,
    paymentPayload: (state) => state.paymentPayload,
    isCleaningInProgress: (state) => state.isCleaningInProgress,
    payNowActivityId: (state) => state.payNowActivityId,
    invoiceData: (state) => state.invoiceData,
    isChargeFlow: (state) => state.isChargeFlow,
    payNowEnrollmentData: (state) => state.payNowEnrollmentData,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/pay-now/pay-now.module.js